<template>
  <el-dialog
    title="编辑任务"
    :visible.sync="showEditDialog"
    width="600px"
    center
    @close="closeEditDialog"
  >
    <el-form ref="form" :model="form" label-width="100px">
      <!-- 任务名称 -->
      <el-form-item label="任务名称" prop="name" :rules="nameRules">
        <el-input v-model="form.name" placeholder="请输入任务名称" />
      </el-form-item>
      <!-- 爬取页数 -->
      <el-form-item label="爬取页数" prop="page" :rules="pageRules">
        <el-input-number
          v-model="form.page"
          :min="1"
          placeholder="请输入爬取页数"
          style="width: 100%"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="closeEditDialog">取消</el-button>
      <el-button type="primary" @click="submitEditTask">确认</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { updateTask } from '@/api/miniAd'

export default {
  name: 'EditTaskDialog',
  data() {
    return {
      form: {
        id: null,
        name: '',
        page: null
      },
      nameRules: [
        { required: true, message: '任务名称不能为空', trigger: 'blur' }
      ],
      pageRules: [
        { required: true, message: '爬取页数不能为空', trigger: 'blur' },
        { type: 'number', message: '爬取页数必须是数字', trigger: 'blur' }
      ]
    }
  },
  computed: {
    ...mapGetters('dialog', ['showEditTaskDialog', 'editTaskData']),
    showEditDialog: {
      get() {
        return this.showEditTaskDialog
      },
      set(value) {
        if (!value) {
          this.closeEditDialog()
        }
      }
    }
  },
  watch: {
    editTaskData: {
      handler(newData) {
        // 确保数据类型正确
        this.form = {
          id: parseInt(newData.id, 10) || null,
          name: newData.name || '',
          page: parseInt(newData.page, 10) || null
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('dialog', ['closeEditTaskDialog']),
    async submitEditTask() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          try {
            // 确保提交前的 id 和 page 为整数
            const payload = {
              id: parseInt(this.form.id, 10),
              name: this.form.name,
              page: parseInt(this.form.page, 10)
            }

            await updateTask(payload)
            this.$message.success('任务更新成功！')
            this.closeEditDialog()
            this.$emit('taskUpdated') // 通知父组件刷新列表
          } catch (error) {
            this.$message.error('任务更新失败，请稍后重试！')
          }
        }
      })
    },
    closeEditDialog() {
      this.closeEditTaskDialog()
    }
  }
}
</script>

<style scoped></style>
